import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgFlag = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 13 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M1.89 1.594h9.7l-1.734 3.48 1.734 3.5h-9.7m0-6.98v6.98m0-6.98V.08m0 8.492v4.008m0 0H.41m1.48 0h1.522" />
  </svg>
);
const Memo = memo(SvgFlag);
export default Memo;
